module.exports = __webpack_public_path__ + "static/media/logo-square-transparent.0304d50d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo-square-transparent.png
// module id = 329
// module chunks = 0